"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERight = exports.ELeft = void 0;
/**
 *
 * This method should be used when there's an expected error
 *
 * @param { any } result
 * @returns { IEither }
 */
const ELeft = (result) => {
    return {
        type: "ERROR" /* EITHER_TYPE.ERROR */,
        result: result,
    };
};
exports.ELeft = ELeft;
/**
 *
 * This method should be used when there's an expected success outcome
 *
 * @param result
 * @returns
 */
const ERight = (result) => {
    return {
        type: "SUCCESS" /* EITHER_TYPE.SUCCESS */,
        result: result,
    };
};
exports.ERight = ERight;
//# sourceMappingURL=utils.js.map